import { motion } from "@/components/motion";
import { CheckCircle } from "lucide-react";

const reasons = [
  "Consistent Quality — ISI-certified materials from trusted manufacturers",
  "Competitive Pricing — Best rates without compromising on quality",
  "Timely Delivery — Efficient logistics across India",
  "Wide Product Range — MS, GI, ERW, Seamless, Fittings & Valves",
  "35+ Years Experience — Trusted since 1990",
  "Customer Satisfaction — Dedicated support for every project",
];

const WhyChooseUs = () => (
  <section className="py-20 md:py-28 bg-card">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-accent-strong font-display text-sm uppercase tracking-[0.2em] mb-2">
            Our Promise
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            Why Choose Taher Steel?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {reasons.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-start gap-3 p-4 rounded-lg bg-card border border-border"
            >
              <CheckCircle className="w-5 h-5 text-accent mt-0.5 shrink-0" />
              <p className="font-body text-sm text-foreground leading-relaxed">
                {r}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
